<div fxFlex="100" fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20">
  <mat-card style="margin-top: 20px; margin-bottom: 20px;">
    <mat-card-header>
      <mat-card-title>
        Admin-Mitarbeiter
      </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="loadingSubs">
      <mat-spinner diameter="30"></mat-spinner>
    </mat-card-content>
    <mat-card-content *ngIf="!loadingSubs">
      <div class="alert-info" *ngIf="subAdmins.data.length == 0">
        Sie haben noch keine Admin-Mitarbeiter angelegt.
      </div>
      <div class="alert-info" *ngIf="subAdmins.data.length > 0 && filteredSubAdmins.data.length == 0">
        Es gibt keine Admin-Mitarbeiter, die zu Ihren Filtereinstellungen passen.
      </div>
      <table mat-table [hidden]="filteredSubAdmins.data.length == 0" [dataSource]="filteredSubAdmins" matSort style="width: 100%;" >
        <ng-container matColumnDef="kundenkennung">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            Kundenkennung (Login)
          </th>
          <td mat-cell *matCellDef="let element">
            <span >
              <i *ngIf="!element.kundenkennung">wird generiert...</i>
              <strong *ngIf="element.kundenkennung">{{element.kundenkennung}}</strong>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="vorname">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            Vorname
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field *ngIf="element.edit">
              <mat-label>Vorname</mat-label>
              <input matInput [(ngModel)]="element.vorname">
            </mat-form-field>
            <span *ngIf="!element.edit">
              {{element.vorname}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="nachname">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            Nachname
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field *ngIf="element.edit">
              <mat-label>Nachname</mat-label>
              <input matInput [(ngModel)]="element.nachname">
            </mat-form-field>
            <span *ngIf="!element.edit">
              {{element.nachname}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            E-Mail
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field *ngIf="element.edit">
              <mat-label>E-Mail</mat-label>
              <input matInput [(ngModel)]="element.email" type="email" required>
            </mat-form-field>
            <span *ngIf="!element.edit">
              {{element.email}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef style="text-align: right !important;">
            Aktionen
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: right;">
            <button mat-raised-button [disabled]="element.saving" color="primary" *ngIf="element.edit" (click)="saveSubAdmin(element)">
              Speichern
            </button>
            <button mat-raised-button [disabled]="element.saving" color="warn" *ngIf="!element.edit" (click)="deleteSubAdmin(element)">
              Löschen
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['kundenkennung', 'vorname', 'nachname', 'email','action']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['kundenkennung', 'vorname', 'nachname', 'email','action'];"></tr>
      </table>
    </mat-card-content>
    <mat-card-footer>
      <button mat-raised-button color="primary" style="width: 100%;" (click)="addSubAdmin()">
        Admin-Mitarbeiter hinzufügen
      </button>
    </mat-card-footer>
  </mat-card>
</div>
